import Layout from '@/components/core/Layout';
import { useTheme } from '@/stores/settingsStore';
import { useEffect } from 'react';
import { Outlet } from 'react-router';

const RootRouter = () => {
  const theme = useTheme();

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

export default RootRouter;
